var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Lock",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.2 16",
    style: {
      enableBackground: "new 0 0 12.2 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B4A64;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_lock_24px",
    className: "st0",
    d: "M10.7,5.3H9.9V3.8C9.9,1.7,8.1,0,6,0.1C4,0.1,2.3,1.8,2.3,3.8v1.5H1.5C0.7,5.3,0,6,0,6.9v7.6 C0,15.3,0.7,16,1.5,16h9.1c0.8,0,1.5-0.7,1.5-1.5V6.9C12.2,6,11.5,5.3,10.7,5.3z M6.1,12.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5 c0.8,0,1.5,0.7,1.5,1.5C7.6,11.5,6.9,12.2,6.1,12.2z M8.5,5.3H3.7V3.8c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4L8.5,5.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.cc56cfd20f0625583c2473fdf9517496.svg";
export { ForwardRef as ReactComponent };